import React from 'react';

const Dable = () => {
  return (
    <div className="box_blog box_blog_type2">
      <div className="wrap_logo">
        <img src="//t1.daumcdn.net/tistory_admin/static/manage/images/temp/dable.png"
             alt="Dable" className="company_logo" width="98"/>
      </div>
      <div className="wrap_cont">
        <strong className="screen_out">특징</strong>
        <ul className="list_cont ">
          <li><span className="ico_blog ico_check_type3"/><span className="txt_g">개인화 추천을 통한 트래픽 및 주목도 상승</span>
          </li>
          <li><span className="ico_blog ico_check_type3"/><span
            className="txt_g">블로그에 딱 맞는 알고리즘 및 디자인 지원을 통한 수익 극대화</span>
          </li>
          <li><span className="ico_blog ico_check_type3"/><span
            className="txt_g">효과적이고, 강력한 테스트 툴 제공</span></li>
        </ul>
      </div>
      <span className="btn_type5 btn_type5_type1">준비 중</span>
    </div>
  )
};

export default Dable;